/* istanbul ignore file */
import React from 'react';
import { ARTIFACT_ID } from '../constants';
import ArtifactUploaderInput, { ArtifactUploaderInputProps } from './ArtifactUploaderInput';

const EmailAttachmentUploaderInput = (props: ArtifactUploaderInputProps) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.EMAIL_ATTACHMENT} />;
};

export default EmailAttachmentUploaderInput;
